export { ArrowCaretDownMd2 } from "./ArrowCaretDownMd2";
